import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const addProduct = data => post(URL.ADD_PRODUCTS, data);
export const editProduct = data => post(URL.EDIT_PRODUCTS, data);
export const getProductsList = data => post(URL.GET_PRODUCTS, data);
export const deleteProduct = data => post(URL.DELETE_PRODUCT, data);
export const getCategoryList = data => post(URL.GET_CATEGORIES, data);
export const getProductDetail = data => post(URL.GET_PRODUCTS_DETAIL, data);
export const getSubCategoriesList = data => post(URL.GET_SUB_CATEGORIES, data);
export const deleteProductImage = data => post(URL.DELETE_PRODUCT_IMAGE, data);
export const getModelList = data => post(URL.GET_MODEL_LIST, data);
